module.exports = __webpack_public_path__ + "fonts/fs_lola-medium-webfont.02e0c90a.ttf";